const colors = {
	white: '#fff',
	black: '#161537',
	blue: '#1b55e3',
	yellow: '#ff0',
	orange: '#ff8200',
	red: '#f2135d',
	pink: '#fd3995',
	purple: '#5b3cc4',
	'blue-light': '#3d6ee7',
	'gray-1': '#f2f4f8',
	'gray-2': '#e4e9f0',
	'gray-3': '#dde2ec',
	'gray-4': '#c3bedc',
	'gray-5': '#aca6cc',
	'gray-6': '#786fa4',
};

const bsColors = {
	default: colors['gray-4'],
	primary: colors.blue,
	secondary: '#6a7a84',
	success: '#17c964',
	info: colors.blue,
	warning: colors.orange,
	danger: colors.red,
	light: colors['gray-1'],
	dark: colors.black,
};

const variables = {
	apiPath: 'https://app.michollo.com/api/',
	cdnPath: 'https://img.michollo.com',
	trackPath: 'https://michollo.to/api/v1',
};

variables.defaultImageDeal = `${variables.cdnPath}/assets/img/resources/noImageProduct.jpg`;
variables.defaultImageUser = `${variables.cdnPath}/assets/img/resources/noImageAvatar.jpg`;

export default {
	...variables,
	colors: { ...colors, ...bsColors },
};
